export default "\n<router-outlet></router-outlet>\n<app-footer></app-footer>"